module.exports = __webpack_public_path__ + "static/blank-tile-d6e0787c294f3bb014f73022adf4bfed.jpg";